import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthResponseData, AuthService } from '../service/auth.service';
import * as moment from 'moment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  isLoading = false;
  error: any = null;
  step = 0;
  userData = { email: '', code: '' };
  regData: any = {};
  user: any = {};

  bsDate:any = null;
  bsValueB = null;
  maxDate = moment().add('year', 1).toDate();
  weightMode = 'metric';
  weight = 0;
  weightStone = 0;
  weightPounds = 0;
  heightMode = 'metric';
  height = 0;
  heightFeet = 0;
  heightInches = 0;
  password1 = '';
  password2 = '';
  modalRef?: BsModalRef;
  toggleEthnicityOther = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    // are we logged in?
    const user = this.authService.user.getValue();
    if (user) {
      if (this.authService.redirect) {
        this.router.navigate([this.authService.redirect]);
      } else {
        this.router.navigate(['/dashboard']);
      }
    }
  }

  onNext(event: any) {
    this.step++;
    window.scroll(0, 0);
  }
  onPrev(event: any) {
    this.step--;
    window.scroll(0, 0);
  }

  onSubmit(form: NgForm) {
    if (!form.valid) {
      return;
    }
    const code = form.value.code;
    const email = form.value.email;
    let authObs: Observable<AuthResponseData>;

    this.isLoading = true;

    authObs = this.authService.checkCode(code, email);

    authObs.subscribe(
      (resData) => {
        // console.log(resData);
        this.error = null;
        this.isLoading = false;
        this.step = 1;
        this.populateRegForm(resData);
        this.user.code = code;
        this.user.email = email;
        window.scroll(0, 0);
      },
      (errorMessage) => {
        this.error = 'Your code or email address were not recognised.';
        this.isLoading = false;
      }
    );
  }

  private populateRegForm(responseData: any) {
    this.user.first_name = responseData.user.first_name;
    this.user.last_name = responseData.user.last_name;
    this.user.username = responseData.user.username;
    this.user.smoke = responseData.user.smoke;
    this.user.drink = responseData.user.drink;
    this.regData.opAreas = responseData.regData.opAreas;
    this.user.op_area_id = responseData.user.op_area_id;
    if (responseData.user.surgery_date) {
      this.bsDate = moment(responseData.user.surgery_date).toDate();
    }
  }

  onSubmitRegistration(form: NgForm) {
    this.isLoading = true;
    if (!form.valid) {
      this.isLoading = false;
      return;
    }


    let drinkValue = form.value.personalDetails.drink;
    if(!drinkValue){drinkValue = 0;}else{drinkValue=1;}
    let smokeValue = form.value.personalDetails.smoke;
    if(!smokeValue){smokeValue = 0;}else{smokeValue=1;}

    let surgeryDate = '';
    if(form.value.surgeryDetails.surgery_date){
      surgeryDate =  moment(form.value.surgeryDetails.surgery_date)
      .format('YYYY-MM-DD')
      .toString()
    }
    this.authService
      .register(
        this.user.email,
        this.user.code,
        form.value.accountSetup.passwords.password,
        form.value.personalDetails.firstName,
        form.value.personalDetails.lastName,
        form.value.personalDetails.username,
        smokeValue,
        drinkValue,
        surgeryDate,
        form.value.surgeryDetails.op_area_id
      )
      .subscribe(
        (resData) => {
          // console.log(resData);
          this.isLoading = false;
          this.router.navigate(['/welcome']);
        },
        (errorMessage) => {
          this.error = errorMessage;
          this.isLoading = false;
          window.scroll(0, 0);
        }
      );
  }
  onCheckScreenName(elem: any) {
    // console.log(elem);
  }

  checkPassword(password: string, check: string) {
    switch (check) {
      case 'upper':
        return /[A-Z]/.test(password);
        break;
      case 'lower':
        return /[a-z]/.test(password);
        break;
      case 'num':
        return /[0-9]/.test(password);
        break;
      case 'special':
        return /[$@$!%*?&]/.test(password);
        break;
    }
    return false;
  }

  trackByIndex = (index: number): number => {
    return index;
  };
}
